import moment from 'moment'
import { createAction } from 'redux-api-middleware'
import type { RootState } from '../../reducers'
import { HUBBLE_API_TOKEN } from '../../store/middleware/APIUrl'
import type { TicketSize } from '../../types'
import ActionTypes from './actionTypes'
import { ArrayUtils, ObjectUtils } from '../../utils'

type TicketSizeUpdateRequest = {
    type: typeof ActionTypes.TICKET_SIZE_UPDATE_REQUEST;
    payload: never;
}

type TicketSizeUpdateFailure = {
    type: typeof ActionTypes.TICKET_SIZE_UPDATE_FAILURE;
    payload: Error;
}

type TicketSizeUpdateSuccess = {
    type: typeof ActionTypes.TICKET_SIZE_UPDATE_SUCCESS;
    payload: TicketSize;
}

const UpdateTicketSizeFields = [
    'size',
    'start_date',
    'end_date',
    'skus',
    'storecodes',
] as const

const sanitizeArrayToCSV = (v: unknown) => {
    if (!Array.isArray(v)) return ''
    return ArrayUtils.cleanStringArray(v)
}

function updateTicketSize(ticketSize: TicketSize) {
    const body = ObjectUtils.copy(ticketSize, UpdateTicketSizeFields, {
        start_date: (v: Date) => moment(v).format('YYYY-MM-DD'),
        end_date: (v: Date) => moment(v).format('YYYY-MM-DD'),
        skus: sanitizeArrayToCSV,
        storecodes: sanitizeArrayToCSV,
    })

    return createAction<RootState, TicketSize, never>({
        endpoint: `${HUBBLE_API_TOKEN}/ticket-sizes/${ticketSize.id}`,
        method: 'PUT',
        body: JSON.stringify(body),
        types: [
            ActionTypes.TICKET_SIZE_UPDATE_REQUEST,
            ActionTypes.TICKET_SIZE_UPDATE_SUCCESS,
            ActionTypes.TICKET_SIZE_UPDATE_FAILURE,
        ],
    })
}

export type TicketSizeUpdateAction = TicketSizeUpdateRequest
    | TicketSizeUpdateFailure
    | TicketSizeUpdateSuccess

export default updateTicketSize
